import ActionType from '../constants/actionTypes'

export function requireQuestion() {
  return {
    type: ActionType.QUESTION_REQUIRED
  }
}

export function requestQuestions() {
  return {
    type: ActionType.FETCH_QUESTIONS_REQUEST
  }
}

export function fetchQuestionsSuccess(payload) {
  return {
    type: ActionType.FETCH_QUESTIONS_SUCCESS,
    payload
  }
}

export function fetchQuestionsFailure(error) {
  return {
    type: ActionType.FETCH_QUESTIONS_FAILURE,
    error
  }
}

export function selectQuestion(payload) {
  return {
    type: ActionType.SELECT_QUESTION,
    payload
  }
}



// WEBPACK FOOTER //
// ./client/modules/debate/actions/question.js